export default __webpack_public_path__ + "static/media/background4.01f2d4af.png";